import React, { useState } from 'react';

import {
    Toolbar,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    TablePagination,
    Grid,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { grey } from '@material-ui/core/colors';

import Alert from '../../components/Alert';
import SideMenu from '../../components/SideMenu';
import InputSearch from '../../components/InputSearch';

import api from '../../services/api';
import date from '../../utils/date';
import { ListPageHeading, ListTableCard, listResultSubtitle } from '../../components/ListPageLayout';

export default function CredentialList() {
    const classes = useStyles();

    const [credentials, setCredentials] = useState([]);
    const [total, setTotal] = useState(0);
    const [page, setPage] = useState(0);
    const [limit, setLimit] = useState(10);
    // const [refresh, setRefresh] = useState(true);
    const [message, setMessage] = useState({
        open: false,
        variant: '',
        text: '',
    });

    function updateRequest({ search }) {

        const loadData = async () => {
            try {
                const result = await api.get('/credential/list', {
                    params: {
                        search,
                        limit,
                        page,
                    },
                });

                const { count, credentials } = result.data;

                setCredentials(credentials);
                setTotal(count);
                // setRefresh(false);
            } catch (err) {
                setMessage({
                    open: true,
                    variant: 'error',
                    text: err.error || 'Não foi possivel carregar as credenciais',
                });
            }
        };

        loadData();

    }

    const changePage = (_, newPage) => {
        setPage(newPage);
    };

    const quantityPerPage = ({ target }) => {
        setLimit(parseInt(target.value, 10));
        setPage(0);
    };

    const closeMessage = () => {
        setMessage({
            open: false,
            variant: '',
            text: '',
        });
    };
    return (
        <div className={classes.root}>
            <SideMenu />
            <main className={classes.content}>
                <Toolbar />
                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        <ListPageHeading icon="credential" title="Lista de Credenciais" />
                    </Grid>

                    <Grid item xs={12}>
                        <ListTableCard
                            title="Credenciais cadastradas"
                            subtitle={listResultSubtitle(total)}
                            actions={(
                                <InputSearch
                                    textFieldProps={{
                                        placeholder: 'Buscar…',
                                    }}
                                    request={updateRequest}
                                    pagination={[page, limit]}
                                    className={classes.inputSearch}
                                />
                            )}
                        >
                            <TableContainer component={Paper}>
                                <Table className={classes.table} size="small" aria-label="access history">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell className={classes.tableHead}>ID</TableCell>
                                            <TableCell className={classes.tableHead}>Número</TableCell>
                                            <TableCell className={classes.tableHead}>Status</TableCell>
                                            <TableCell className={classes.tableHead}>Inicio da Validade</TableCell>
                                            <TableCell className={classes.tableHead}>Fim da Validade</TableCell>
                                            <TableCell className={classes.tableHead}>Usuário Vinculado</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {!!credentials && credentials.map(credential => (
                                            <TableRow key={credential.id}>
                                                <TableCell className={classes.tableBody} component="th" scope="row">
                                                    {credential.id}
                                                </TableCell>
                                                <TableCell className={classes.tableBody}>
                                                    {credential.number}
                                                </TableCell>
                                                <TableCell className={classes.tableBody}>
                                                    {credential.active ? "ATIVADA" : "DESATIVADA"}
                                                </TableCell>
                                                <TableCell className={classes.tableBody}>
                                                    {
                                                        credential.validity_begin
                                                            ? date(credential.validity_begin).toLocaleFormat()
                                                            : "-"
                                                    }
                                                </TableCell>
                                                <TableCell className={classes.tableBody}>
                                                    {
                                                        credential.validity_end
                                                            ? date(credential.validity_end).toLocaleFormat()
                                                            : "-"
                                                    }
                                                </TableCell>
                                                <TableCell className={classes.tableBody}>
                                                    {credential.user.name ? credential.user.name : "-"}
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </ListTableCard>
                        <TablePagination
                            rowsPerPageOptions={[10, 20, 30]}
                            component="div"
                            count={total}
                            rowsPerPage={limit}
                            page={page}
                            labelDisplayedRows={({ from, to, count }) => `${from}-${to} de ${count}`}
                            labelRowsPerPage="Registros por página"
                            onChangePage={changePage}
                            onChangeRowsPerPage={quantityPerPage}
                        />
                    </Grid>
                </Grid>
                {!!message.open && (
                    <Alert
                        open={message.open}
                        autoHideDuration={6000}
                        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                        severity={message.variant}
                        onClose={closeMessage}
                    >
                        {message.text}
                    </Alert>
                )}
            </main>
        </div>
    )

}
const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
    },
    content: {
        flexGrow: 1,
        padding: theme.spacing(3),
        marginBottom: theme.spacing(6),
        marginTop: theme.spacing(5),
    },
    title: {
        color: grey[700],
        fontSize: 28,
    },
    table: {
        minWidth: 500,
        width: '100%',
    },
    inputSearch: {
        width: 340,
        maxWidth: '100%',
        '& .MuiTextField-root': {
            width: '100%',
        },
        '& .MuiOutlinedInput-root': {
            minHeight: 40,
            borderRadius:20,
            backgroundColor: '#f9fafb',
            transition: 'background-color 160ms ease, box-shadow 160ms ease',
            '&:hover': {
                backgroundColor: '#fff',
            },
            '&.Mui-focused': {
                backgroundColor: '#fff',
                boxShadow: '0 0 0 3px rgba(37, 99, 235, 0.10)',
            },
        },
        '& .MuiOutlinedInput-notchedOutline': {
            borderColor: '#dfe3e8',
        },
        [theme.breakpoints.down('sm')]: {
            width: '100%',
        },
    },
    tableHead: {
        fontWeight: 700,
        textAlign: 'center',
        padding: '14px 10px',
        textTransform: 'uppercase',
        backgroundColor: '#f5f7fa',
        color: '#374151',
        letterSpacing: '0.04em',
        fontSize: '0.75rem',
        position: 'sticky',
        top: 0,

    },
    
    tableBody: {
        color: '#374151',
        padding: '14px 10px',
        textAlign: 'center',
        fontSize: 14,
        fontWeight: 600,
        borderBottom: '1px solid #eef1f5',
    },
    actionButton: {
        margin: theme.spacing(0, .5),
        padding: theme.spacing(.5, 0),
        minWidth: 30,
        borderRadius: 9,
    },
    fabButton: {
        position: 'fixed',
        bottom: 0,
        right: 0,
        margin: theme.spacing(3),
    },
}));
